import React from 'react';
import { motion } from 'framer-motion';
import { Filter, MessageSquare, ShieldCheck } from 'lucide-react';
export function UniqueMethod() {
  return <section className="bg-navy text-white py-24 px-6" data-id="element-284">
      <div className="max-w-3xl mx-auto" data-id="element-285">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-286">
          <h3 className="text-amber-500 font-bold tracking-wider text-sm uppercase mb-3" data-id="element-287">
            El Método de la Clave de Paz
          </h3>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-offwhite mb-6" data-id="element-288">
            Protocolo de Respuesta Blindada
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg text-slate-300 leading-relaxed space-y-6 mb-12" data-id="element-289">
          <p data-id="element-290">
            No es psicología barata ni frases de autoayuda. Es un{' '}
            <strong className="text-white font-bold" data-id="element-291">
              sistema de gestión de crisis
            </strong>{' '}
            diseñado para que te vuelvas "invisible" al drama.
          </p>
          <p data-id="element-292">
            Aprendés a filtrar el ruido del dato, a responder como un escribano
            y a poner una pared de concreto entre tu vida privada y el caos de
            tu ex. La prioridad absoluta son tus hijos, y para cuidarlos a
            ellos, primero tenés que recuperar tu centro vos.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-293">
          {[{
          icon: Filter,
          title: 'Filtrar',
          desc: 'Separar el ruido del dato útil.'
        }, {
          icon: MessageSquare,
          title: 'Responder',
          desc: 'Comunicación aséptica y logística.'
        }, {
          icon: ShieldCheck,
          title: 'Blindar',
          desc: 'Bloquear el reingreso del conflicto.'
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3 + i * 0.1
        }} className="bg-slate-800 p-6 rounded-xl border border-slate-700 text-center flex flex-col items-center" data-id="element-294">
              <div className="bg-slate-700 p-4 rounded-full mb-4 text-amber-500" data-id="element-295">
                <item.icon size={28} data-id="element-296" />
              </div>
              <h4 className="text-white font-bold text-xl mb-2" data-id="element-297">
                {item.title}
              </h4>
              <p className="text-slate-400 text-sm" data-id="element-298">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}